module.exports = __webpack_public_path__ + "img/upload.b42a6c65.svg";